import React, { useState, useEffect } from "react";

const CommonDropdownMenufour = ({
  cls = "",
  options = [],
  suboption = [],
  rawselectedOption,
  handleOptionSelect = () => {},
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(options[0] || "");

  useEffect(() => {
    if (rawselectedOption) {
      setSelectedOption(rawselectedOption);
      handleOptionSelect(rawselectedOption);
    }
  }, [rawselectedOption]);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
    handleOptionSelect(option);
  };

  return (
    <div className={`dropdown-wrapper position-relative ${cls}`} style={{ width: '100%' }}>
      {/* Header */}
      <div
        className="dropdown-header d-flex justify-content-between align-items-center px-3 py-2 border rounded bg-white"
        style={{ cursor: 'pointer' }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-truncate">{selectedOption}</span>
        <i className={`fa-solid ${isOpen ? 'fa-caret-up' : 'fa-caret-down'}`}></i>
      </div>

      {/* Dropdown List */}
      {isOpen && (
        <div
          className="dropdown-list position-absolute bg-white shadow border mt-1 rounded"
          style={{
            zIndex: 1000,
            width: '100%',
            maxHeight: '200px',
            overflowY: 'auto',
          }}
        >
          {options.map((option, index) => (
            <div
              key={index}
              className="px-3 py-2 border-bottom"
              style={{ cursor: 'pointer' }}
              onClick={() => handleOptionClick(option)}
            >
              <div className="fw-bold">{option}</div>
              {suboption[index] && (
                <div className="text-muted small text-wrap">{suboption[index]}</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CommonDropdownMenufour;
